/*
 * Copyright (c) 2024. Bluemate B.V.
 */

import {ReviewSalesPeriod, ReviewTab} from './interfaces';

type AnalyticsMem = {
    period: ReviewSalesPeriod | null;
    tab: ReviewTab | null;
    tablePage: number;
    tableSearch: string | null;
    tableLimit: number | null;
    tableSort: string | null;
    tableSortOrder: number | null;
};

let analyticsMem: AnalyticsMem = {
    period: null,
    tab: null,
    tablePage: 0,
    tableSearch: null,
    tableLimit: null,
    tableSort: null,
    tableSortOrder: null
};

export function setReviewAnalyticsMemValue(key: keyof AnalyticsMem, value: any) {
    analyticsMem[key] = value as never;
}

export function getReviewAnalyticsMemValue(key: keyof AnalyticsMem): any {
    return analyticsMem[key];
}

export function getReviewAnalyticsMem(): AnalyticsMem {
    return analyticsMem;
}

export function resetReviewAnalyticsMem() {
    analyticsMem = {
        period: ReviewSalesPeriod.THIRTY_DAYS,
        tab: ReviewTab.FEED,
        tablePage: 0,
        tableSearch: null,
        tableLimit: null,
        tableSort: null,
        tableSortOrder: null
    };
}
